import { render, staticRenderFns } from "./BasicInput.vue?vue&type=template&id=e1a5318a&scoped=true&"
import script from "./BasicInput.vue?vue&type=script&lang=js&"
export * from "./BasicInput.vue?vue&type=script&lang=js&"
import style0 from "./BasicInput.vue?vue&type=style&index=0&id=e1a5318a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a5318a",
  null
  
)

export default component.exports